import { useState, useEffect, useRef, useCallback } from "react";

const useStickyHeader = (defaultSticky = false) => {
  const [yPosition, setYPosition] = useState(0);
  const [isSticky, setIsSticky] = useState(defaultSticky);
  const tableRef = useRef(null);
  const toggleSticky = useCallback(
    ({ top, bottom }) => {
      if (top <= 0 && bottom > 2 * 68) {
        !isSticky && setIsSticky(true);
      } else {
        isSticky && setIsSticky(false);
      }
    },
    [isSticky]
  );
  let stickyStyle = {};

  useEffect(() => {
    const handleScroll = () => {
      setYPosition(tableRef.current.getBoundingClientRect().y);
      toggleSticky(tableRef.current.getBoundingClientRect());
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [toggleSticky]);

  stickyStyle = isSticky
    ? {
      position: "relative",
      top: `${Math.abs(yPosition)}px`,
      zIndex: 1000,
    }
    : {};

  return { tableRef, isSticky, stickyStyle };
};

export default useStickyHeader;
